import '../node_modules/@shoelace-style/shoelace/dist/components/qr-code/qr-code.js'
import '../node_modules/htmx.org/dist/htmx.js'
import '../node_modules/simpledotcss/simple.min.css'
